<template>
    <div>
        <b-row class="mb-4">
            <b-col>
                <h1>
                    <span>Base de Conhecimento</span>
                </h1>
                <btn-inserir-item
                    v-if="$temAcessoView('BASECONH-01')"
                    @atualizarListaItens="itens = [...$event]"
                ></btn-inserir-item>
            </b-col>
        </b-row>
        <b-row>
            <b-col
                sm="12"
                md="6"
                lg="4"
                v-for="item in itens"
                :key="item.itemId"
            >
                <b-card :no-body="true">
                    <b-card-body class="p-0">
                        <b-row>
                            <b-col
                                sm="3"
                                class="bg-info icon-button"
                                @click="obterConteudo(item)"
                            >
                                <div class="centerbox">
                                    <span
                                        ><i
                                            :class="`fa ${item.icone} font-5xl`"
                                        ></i
                                    ></span>
                                </div>
                            </b-col>
                            <b-col sm="9">
                                <div class="pt-2 pb-2 pr-2">
                                    <h4>{{ item.nome }}</h4>
                                    {{ item.descricao }}
                                </div>
                                <div>
                                    <div class="float-left">
                                        <btn-ativar-desativar-item
                                            class="mr-2"
                                            :item="item"
                                            v-if="$temAcessoView('BASECONH-01')"
                                            @atualizarListaItens="
                                                itens = [...$event]
                                            "
                                        >
                                        </btn-ativar-desativar-item>
                                        <btn-atualizar-item
                                            class="mr-2"
                                            :item="item"
                                            v-if="$temAcessoView('BASECONH-01')"
                                            @atualizarListaItens="
                                                itens = [...$event]
                                            "
                                        ></btn-atualizar-item>
                                        <btn-excluir-item
                                            :item="item"
                                            v-if="$temAcessoView('BASECONH-01')"
                                            @atualizarListaItens="
                                                itens = [...$event]
                                            "
                                        ></btn-excluir-item>
                                        <b-badge
                                            class="ml-2"
                                            variant="primary"
                                            v-if="$temAcessoView('BASECONH-01')"
                                            >{{
                                                item.nivelAcessoDescr
                                            }}</b-badge
                                        >
                                    </div>
                                    <div class="float-right pb-1 pr-2">
                                        <small class="text-muted"
                                            >Atualizado em
                                            {{
                                                $moment(
                                                    item.dataAtualizacao
                                                ).format('DD/MM/YYYY HH:mm')
                                            }}</small
                                        >
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BaseConhecimentoServicos from './BaseConhecimentoServicos'
import BtnInserirItem from './BtnInserirItem'
import BtnExcluirItem from './BtnExcluirItem'
import BtnAtivarDesativarItem from './BtnAtivarDesativarItem'
import BtnAtualizarItem from './BtnAtualizarItem'

export default {
    components: {
        BtnInserirItem,
        BtnExcluirItem,
        BtnAtivarDesativarItem,
        BtnAtualizarItem
    },

    data() {
        return {
            itens: []
        }
    },

    methods: {
        obterItens() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.$temAcessoView('BASECONH-01')) {
                promisse = BaseConhecimentoServicos.obterTodosItens()
            } else {
                promisse = BaseConhecimentoServicos.obterItensAtivos()
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.itens = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter Itens',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterConteudo(item) {
            if (item.url) {
                let win = window.open(item.url, '_blank')
                win.focus()
            } else {
                this.$store.dispatch('addRequest')
                BaseConhecimentoServicos.downloadItemLocal(item.itemId).then(
                    response => {
                        if (response) {
                            if (response.type === 'application/json') {
                                this.$toast.error(
                                    'Erro ao realizar download do conteúdo!!!',
                                    'ERROR',
                                    this.$toastConfig.error
                                )
                            } else {
                                this.$download(response, item.conteudo)
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            }
        }
    },

    created() {
        this.obterItens()
    }
}
</script>

<style scoped>
.centerbox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
</style>
